<template>
  <div v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row px-4">
          <div class="w-full flex justify-end gap-4">
            <vs-button
              @click="downloadFile()"
              class="bg_purple float-right mr-4"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("DownloadExcelFile") }}
            </vs-button>
            <div class="flex">
              <div class="w-full">
                <vs-button
                  @click="showFilters = !showFilters"
                  class="bg_purple float-right"
                  ><div class="px-3">
                    <feather-icon
                      icon="FilterIcon"
                      svgClasses="h-4 w-4"
                      class="ico"
                    />
                    {{ $t("Filter") }}
                  </div>
                </vs-button>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row flex px-4 flex-no-wrap" v-if="showFilters">
          <div class="sm:w-1/2 w-full pl-4 flex-shrink">
            <label class="vs-select--label">{{ $t("Search") }}</label>
            <vs-input
              name="user"
              :placeholder="
                $t(
                  'AbilitySearchBrandName_EnglishProductName_FarsiProductName_ItemCode'
                )
              "
              v-model="gridSearchData.keyword"
              @keyup.enter="search()"
              v-trim-space
            />
          </div>
          <div>
            <vs-button
              class="mt-6 p-2"
              color="success"
              type="gradient"
              icon-pack="feather"
              icon="icon-search"
              @click.prevent="search()"
              v-has-permission="'GetAllSaleAgentQuotaWithKeyword'"
            ></vs-button>
          </div>
        </div>
        <div class="vx-row pt-4">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('ItemCode') },
                { title: $t('PersianName') },
                { title: $t('LogicalBalance') },
                { title: $t('PhysicalBalance') },
                { title: $t('CountOfQuota') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 20%">
                  {{ row.itemCode }}
                </td>
                <td style="width: 20%">
                  {{ row.persianProductName }}
                </td>
                <td style="width: 20%">
                  {{ row.logicalBalance }}
                </td>
                <td style="width: 20%">
                  {{ row.physicalBalance }}
                </td>
                <td style="width: 20%">
                  {{ row.count }}
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.b {
  white-space: nowrap !important;
  width: 5px;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
</style>
<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import Loading from "@/components/loading/Loading.vue";

export default {
  name: "saleManagement_Quotas_Charge",
  components: {
    DataGrid,
    Loading,
  },
  data() {
    return {
      showFilters: false,
      gridDataSource: {
        type: "app",
        service:
          "Sales/api/QuotaTransactionsQuery/sale-agent-quotas-with-inventories-with-keyword",
      },
      gridSearchData: {
        keyword: "",
      },
      onDesc: false,
    };
  },

  methods: {
    ...mapActions({
      exportSaleAgentQuotaQueryWithInvertoryBalances:
        "excel/exportSaleAgentQuotaQueryWithInvertoryBalances",
    }),
    isDesc(val) {
      this.onDesc = val;
    },
    downloadFile() {
      this.exportSaleAgentQuotaQueryWithInvertoryBalances(
        this.gridSearchData.keyword
      );
    },
    search() {
      this.$refs.grid.renderGrid(1, true);
    },
  },
};
</script>
